import React from "react";
import styles from "./uni_overview_ranking.module.scss";

export const UniOverviewRanking = ({ ranking }) => {
  return (
    <section className={styles.section_ranking}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2 className={styles.heading}>Ranking</h2>
          <div className={styles.sub_heading}>University Rankings</div>

          <ul className={styles.rankings}>
            {ranking?.length > 0 &&
              ranking
                .filter((rank) => rank.type == "University")
                .map((item, i) => {
                  return (
                    <li className={styles.ranking} key={item.id}>
                      <span className={styles.number}>#</span>
                      <div className={styles.rank}>
                        <span>{item.rankingtype} </span>
                        <span>- {item.companyName} </span>

                        <div className={styles.rank}>
                          {item.ranks?.length > 0 &&
                            item.ranks.slice(0, 6).map((timeline, i) => {
                              return (
                                <div>
                                  #{timeline.rank} at {timeline.year}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </li>
                  );
                })}
          </ul>

          <div className={styles.sub_heading}>Course Rankings</div>
          <div className={styles.course_heading}>Business Courses</div>
          <ul className={styles.rankings}>
            {ranking?.length > 0 &&
              ranking
                .filter((rank) => rank.type == "Course")
                .map((item, i) => {
                  return (
                    <li className={styles.ranking} key={item.id}>
                      <span className={styles.number}>#</span>
                      <div className={styles.rank}>
                        <span>{item.rankingtype} </span>
                        <span>- {item.companyName} </span>

                        <div className={styles.rank}>
                          {item.ranks?.length > 0 &&
                            item.ranks.slice(0, 6).map((timeline, i) => {
                              return (
                                <div>
                                  #{timeline.rank} at {timeline.year}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </li>
                  );
                })}
          </ul>
          {/* <div className={styles.course_heading}>Business Courses</div>
          <ul className={styles.rankings}>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
          </ul> */}

          {/* Tables */}
          {/* <div className={styles.table_wrapper}>
            <table>
              <thead>
                <tr>
                  <th>Courses</th>
                  <th>Duration</th>
                  <th>1st Year Tuition Fees</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span>Undergraduate</span> <span> (2 Courses)</span>
                  </td>
                  <td>4 Years</td>
                  <td>$10k</td>
                </tr>
                <tr>
                  <td>
                    <span>Undergraduate</span> <span>(2 Courses)</span>
                  </td>
                  <td>4 Years</td>
                  <td>$10k</td>
                </tr>
                <tr>
                  <td>
                    <span>Undergraduate</span> <span>(2 Courses)</span>
                  </td>
                  <td>4 Years</td>
                  <td>$10k</td>
                </tr>
                <tr>
                  <td>
                    <span>Undergraduate</span> <span>(2 Courses)</span>
                  </td>
                  <td>4 Years</td>
                  <td>$10k</td>
                </tr>
              </tbody>
            </table>

            <table>
              <thead>
                <tr>
                  <th colSpan="2">Admission Requirements</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>
                    <span>Documents</span>
                  </td>
                  <td>
                    SOP: Needed for few courses LOR: Needed for all courses
                    Essays: Needed for few courses CV: Needed for few courses
                    Additional documents: Required
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Application fees</span>
                  </td>
                  <td>USD 75 - 250</td>
                </tr>
                <tr>
                  <td>
                    <span>Type of deadline</span>
                  </td>
                  <td>Regular</td>
                </tr>
                <tr>
                  <td>
                    <span>Intake Season & Deadlines</span>
                  </td>
                  <td>Fall: 8ᵗʰ Sep 2020 - 5ᵗʰ Jan 202</td>
                </tr>
              </tbody>
            </table>
          </div> */}

          {/* Button */}

          {/* <div className={styles.button_wrapper}>
            <button className="btn btn-bg btn-outline">
              View course wise fees
            </button>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default UniOverviewRanking;
